import { Boxes, ShieldCheck, Zap } from 'lucide-react';

export const loginHighlights = [
  {
    icon: Zap,
    title: 'Asignacion express',
    description: 'Despacha cargas rapido con flujos listos para operar.',
  },
  {
    icon: Boxes,
    title: 'Visibilidad total',
    description: 'Seguimiento claro para trafico, deposito y atencion.',
  },
  {
    icon: ShieldCheck,
    title: 'Seguridad siempre on',
    description: 'Acceso protegido y trazabilidad estable para cada equipo.',
  },
];

export default function LoginBrand({ logo, showLogo = true, compact = false }) {
  return (
    <div className={`login-brand ${compact ? 'login-brand--compact' : ''} space-y-3`}>
      <p className="inline-flex items-center gap-2 rounded-full border border-teal-500/40 bg-white/70 px-4 py-1 text-xs font-semibold uppercase tracking-[0.28em] text-teal-700 shadow-sm backdrop-blur dark:border-teal-300/40 dark:bg-slate-900/60 dark:text-teal-200">
        plataforma logistica
      </p>
      <div className="login-brand__title-row flex items-center gap-3">
        {showLogo && logo && (
          <img
            src={logo}
            alt="SinamonSoft"
            className="login-brand__logo h-12 w-12 flex-shrink-0 rounded-lg shadow-sm"
          />
        )}
        <h1 className="login-brand__title text-4xl font-extrabold tracking-tight text-slate-900 drop-shadow-[0_1px_0_rgba(0,0,0,0.2)] dark:text-slate-100 md:text-5xl xl:text-6xl">
          Sinamon <span className="text-teal-600 dark:text-teal-300">Suite</span>
        </h1>
      </div>
      <p className="login-brand__eyebrow mt-1 text-base text-slate-600/90 dark:text-slate-300">
        Logistica rapida. Equipos enfocados.
      </p>
      <p className="login-brand__copy max-w-xl text-sm text-slate-500 dark:text-slate-400 md:text-base">
        Asignaciones, seguimiento y control operativo desde un acceso sobrio y listo para el ritmo diario.
      </p>
    </div>
  );
}
